import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ overline, title, copy, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-3xl"}>
    {overline && (
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">
          {"// "}{overline}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tighter text-zinc-100 sm:text-5xl">
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-zinc-400 sm:text-lg">{copy}</p>
      </Reveal>
    )}
  </div>
);
